import { useState, useRef } from 'react';
import {
  TabsGroup,
  TabsWrapper,
  HeaderSection,
} from 'cdk-radial';
import { customScrollbar, PageHeaderNavigationTab } from 'cdk-radial';
import styled from 'styled-components';
import ChartFieldSetting from './ChartFieldSetting';

export const StyledContentContainer = styled.div`
  ${customScrollbar};
  background-color: ${({ theme }) => theme.color.additional.light.value};
  color: ${({ theme }) => theme.color.additional.dark.value};
`;

export const SettingsFieldTabs = ({ widget, settings , onChange}: any) => {

  const [draftSettings, setDraftSettings] = useState(settings.fields);
  const fields = settings?.fields || [];
  const [activeNavigationItemIndex, setActiveNavigationItemIndex] = useState(0);
  const itemsRef = useRef([]) as any;

  const handleFieldChange = (fieldName: string, updatedData: any) => {
    setDraftSettings((prev: any) => 
      prev.map((f: any) => 
        f.name === fieldName ? { ...f, ...updatedData } : f
      )
    );
    const newDraft = settings.fields.map((f: any) => 
      f.name === fieldName ? { ...f, ...updatedData } : f
    );
    onChange(newDraft);

};

  // 1. Logic for Tab Clicks
  const handleTabClick = (index: number) => {
    setActiveNavigationItemIndex(index);
  };

  return (
    <>
      <HeaderSection>
        <TabsWrapper>
          <TabsGroup label={'Field Settings'} role="tablist">
            {fields.map((field: any, index: number) => (
              <PageHeaderNavigationTab
                id={`tab-${index}`}
                key={field.name}
                label={field.name}
                onFocus={() =>{}}
                isActive={activeNavigationItemIndex === index}
                onClick={() => handleTabClick(index)}
                role="tab"
                ref={(el: any) => (itemsRef.current[index] = el)}
              />
            ))}
          </TabsGroup>
        </TabsWrapper>
      </HeaderSection>

      <StyledContentContainer>
        {draftSettings[activeNavigationItemIndex] && (
          <div 
            key={draftSettings[activeNavigationItemIndex].name} 
            id={`tab-panel-${activeNavigationItemIndex}`}
          >
            <ChartFieldSetting 
              widget={widget} 
              field={draftSettings[activeNavigationItemIndex]} 
              onChange={(newData:any) => handleFieldChange(draftSettings[activeNavigationItemIndex].name, newData)}
            />
          </div>
        )}
      </StyledContentContainer>
    </>
  );
};